import { BookingSummaryItem, DeliveryMethod, SwiftCardState } from '../types';

export const isPhotoRequired = (item: BookingSummaryItem): boolean => {
  if (item.selectedDeliveryMethod === DeliveryMethod.MTicket) {
    return false;
  }

  return item.swiftCardDetails.swiftCardState === SwiftCardState.New;
};
